import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';
new ScrollHint('.js-scrollable', {
	scrollHintBorderWidth: 10,
	i18n: {
		scrollable: 'スクロール出来ます'
	}
});
